import { z } from 'zod';

export const Email = z.string().trim().toLowerCase().email('E-mail inválido.').max(254);
export const Password = z
  .string()
  .min(8, 'A senha precisa de pelo menos 8 caracteres.')
  .max(128, 'A senha pode ter no máximo 128 caracteres.');

export const SignupInput = z.object({
  name: z.string().trim().min(2, 'Diga como podemos te chamar.').max(60),
  email: Email,
  password: Password,
  inviteCode: z.string().trim().max(64).optional(),
});
export type SignupInput = z.infer<typeof SignupInput>;

export const LoginInput = z.object({
  email: Email,
  password: z.string().min(1, 'Digite a senha.').max(128),
});
export type LoginInput = z.infer<typeof LoginInput>;

export const ChangePasswordInput = z.object({
  currentPassword: z.string().min(1).max(128),
  newPassword: Password,
});
export type ChangePasswordInput = z.infer<typeof ChangePasswordInput>;

export const User = z.object({
  id: z.string(),
  name: z.string(),
  email: z.string(),
  telegramLinked: z.boolean(),
  createdAt: z.string(),
});
export type User = z.infer<typeof User>;

export const SessionResponse = z.object({ user: User });
export type SessionResponse = z.infer<typeof SessionResponse>;

/** Diz à tela de cadastro se o código de convite é exigido. */
export const AuthConfig = z.object({
  signup: z.enum(['open', 'invite', 'closed']),
});
export type AuthConfig = z.infer<typeof AuthConfig>;
